import { Observable } from "rxjs";
import { customAjax } from "../components/ErrorHandler";
import { baseURL } from "./ServiceUtil";
import { EditNotificationItem } from "../models/Notification";
import fetchData from "../utils/fetchData";

export const getNotifications = async (options: {
  page?: number;
  is_read: boolean;
  camera_ids?: number[];
  // auth?: any; // pass auth if needed for headers
}) => {
  const queryParams = new URLSearchParams();

  // Pagination - only fetch the requested page
  if (options.page !== undefined && options.page !== null) {
    queryParams.append("page", String(options.page));
  }

  // Read filter
  queryParams.append("is_read", String(options.is_read));

  // Camera filter
  if (options.camera_ids && options.camera_ids.length > 0) {
    queryParams.append("camera__in", options.camera_ids.join(","));
  }

  const url = `/api/v1/notifications`;

  // Use fetchData to fetch only requested page
  const data = await fetchData(
    url,
    queryParams.toString(),
    "GET"
    // options.auth
  );

  return data; // should be { results, count, ... } for the requested page only
};

// export const getNotifications = (options: {
//   page?: number | "all";
//   is_read: boolean;
//   camera_ids?: number[];
// }): Observable<any> => {
//   let queryParams = "";

//   if (options.page !== undefined && options.page !== null) {
//     if (options.page === "all") {
//       queryParams = new URLSearchParams({ page_size: "all" }).toString();
//     } else {
//       queryParams = new URLSearchParams({
//         page: options.page.toString(),
//       }).toString();
//     }
//   }
//   // Add logic to include is_read parameter
//   queryParams += `${queryParams ? "&" : ""}is_read=${options.is_read}`;

//   // Include camera_ids if provided
//   if (options.camera_ids && options.camera_ids.length > 0) {
//     queryParams += `&camera__in=${options.camera_ids.join(",")}`;
//   }

//   const url = `${baseURL}/notifications${queryParams ? "?" + queryParams : ""}`;

//   return customAjax(url);
// };

// export const editNotifications = (
//   notificationId: number,
//   notificationPayload: EditNotificationItem
// ) =>
//   customAjax(
//     `${baseURL}/notifications/${notificationId}`,
//     "PUT",
//     notificationPayload
//   );

export const editNotification = (
  notificationId: number,
  notificationPayload: EditNotificationItem
) => {
  return fetchData(
    `${baseURL}/notifications/${notificationId}`,
    "", // no filters needed
    "PUT",
    undefined, // auth (optional)
    notificationPayload // body
  );
};

// export const readAllNotification = () =>
//   customAjax(`${baseURL}/notifications/acknowledge_all`, "POST");

export const markAllNotificationsAsRead = async () => {
  return await fetchData("/api/v1/notifications/acknowledge_all", "", "POST");
};
